import { formatDateTime } from "@usas/ui-web/utils/DateFunctions";

export const meetInfoIsComplete = (omeMeetOrgUnitEntryInfoStateObjData, omeMeetOrgUnitEntryRosterPermissionsStateObjData) => {
    let errors = {};

    if (omeMeetOrgUnitEntryInfoStateObjData.hasEntryContact === false) {
        errors.error = 'At least one Entry Contact is required';
    }

    const orgUnitRegistrationStartDate = new Date(formatDateTime(omeMeetOrgUnitEntryRosterPermissionsStateObjData?.orgUnitRegistrationStartDate));
    const orgUnitRegistrationEndDate = new Date(formatDateTime(omeMeetOrgUnitEntryRosterPermissionsStateObjData?.orgUnitRegistrationEndDate));
    const meetEntryStartDate = new Date(formatDateTime(omeMeetOrgUnitEntryInfoStateObjData.meetEntryStartDate));
    const meetEntryEndDate = new Date(formatDateTime(omeMeetOrgUnitEntryInfoStateObjData.meetEntryEndDate));

    if (omeMeetOrgUnitEntryRosterPermissionsStateObjData?.orgUnitAthleteRegistrationAllowed !== true && omeMeetOrgUnitEntryRosterPermissionsStateObjData?.orgUnitAthleteRegistrationAllowed !== false) {
        errors.orgUnitAthleteRegistrationAllowed = 'A selection is required';
    }

    if (omeMeetOrgUnitEntryRosterPermissionsStateObjData?.orgUnitAthleteRegistrationAllowed === true) {
        //Athlete Entry Start Date
        if (orgUnitRegistrationEndDate <= orgUnitRegistrationStartDate) {
            errors.orgUnitRegistrationStartDate = 'Athlete Entry Start Date must be before the Athlete Entry End Date';
        } else if (orgUnitRegistrationStartDate < meetEntryStartDate) {
            errors.orgUnitRegistrationStartDate = `Athlete Entry Start Date must be on or after the Meet Entry Start Date`;
        } else if (orgUnitRegistrationStartDate >= meetEntryEndDate) {
            errors.orgUnitRegistrationStartDate = `Athlete Entry Start Date must be before the Meet Entry End Date`;
        }

        //Athlete Entry End Date
        if (orgUnitRegistrationEndDate <= orgUnitRegistrationStartDate) {
            errors.orgUnitRegistrationEndDate = 'Athlete Entry End Date must be after the Athlete Entry Start Date';
        } else if (orgUnitRegistrationEndDate > meetEntryEndDate) {
            errors.orgUnitRegistrationEndDate = `Athlete Entry End Date must be on or before the Meet Entry End Date`;
        } else if (orgUnitRegistrationEndDate <= meetEntryStartDate) {
            errors.orgUnitRegistrationEndDate = `Athlete Entry End Date must be after the Meet Entry Start Date`;
        }
    }

    if (Object.keys(errors).length > 0) {
        return false;
    }
    else if (Object.keys(errors).length === 0) {
        return true;
    }
};

export const rosterEntriesIsComplete = (omeMeetOrgUnitEntryInfoStateObjData) => {
    if (omeMeetOrgUnitEntryInfoStateObjData.hasRosterAthlete === false || omeMeetOrgUnitEntryInfoStateObjData.hasApprovedEvents === false || omeMeetOrgUnitEntryInfoStateObjData.rosterAthleteCountAllowed === false) {
        return false;
    }

    return true;
};

export const credentialsIsComplete = (omeMeetOrgUnitEntryInfoStateObjData) => {
    if (omeMeetOrgUnitEntryInfoStateObjData.credentialsAmountAllowed === false) {
        return false;
    }

    return true;
};

export const submitIsComplete = () => {
    return true;
};